export default [
    {
      path: "/meeting-sign",
      name: "MeetingSign",
      component: (resolve) => require(["@/views/mobileView/singPage/index.vue"], resolve),
    },
  ];
  